export default (store) => {
    const mapsApiKey = _.get(store.state, 'company.credentials.google_api_key');

    if(!mapsApiKey) {
        console.error('No google maps api key provided');
        return;
    }

    // Create the script tag, set the appropriate attributes
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${mapsApiKey}&callback=initMap&libraries=places,drawing&language=${store.ng.injector.get('$translate').use()}`;
    script.defer = true;
    script.async = true;

    // Attach your callback function to the `window` object
    window.initMap = function () {
        // JS API is loaded and available
    };

    // Append the 'script' element to 'head'
    document.head.appendChild(script);
}



// WEBPACK FOOTER //
// ./src/app/store/users/actions/load-google-maps.js